import React, { Suspense, Component } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '../Routes/routes';

class ErrorBoundary extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center">
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
          <h5 style={{ color: '#0f172a' }}>Something went wrong</h5>
          <p className="text-muted small">Please refresh the page or go back.</p>
          <button className="btn btn-primary btn-sm mt-2" onClick={() => window.location.reload()}>
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const Loader = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);

const AppContent = () => (
  <ErrorBoundary>
    <Suspense fallback={<Loader />}>
      <Routes>
        {routes.map((route, idx) =>
          route.element && (
            <Route key={idx} path={route.path} exact={route.exact} name={route.name} element={route.element} />
          )
        )}
        <Route path="/" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </Suspense>
  </ErrorBoundary>
);

export default React.memo(AppContent);
